import { AUTH_API } from "./authApi";

function qs(params = {}) {
    const q = new URLSearchParams();

    for (const [key, value] of Object.entries(params)) {
        if (value === undefined || value === null || value === "") continue;
        q.set(key, String(value));
    }

    const s = q.toString();
    return s ? `?${s}` : "";
}

async function publicFetch(path) {
    const url = `${AUTH_API}${path}`;

    const res = await fetch(url, {
        method: "GET",
        headers: {
            Accept: "application/json",
        },
    });

    const text = await res.text();

    let data = null;

    try {
        data = text ? JSON.parse(text) : null;
    } catch {
        const preview = String(text || "").slice(0, 180);

        throw new Error(
            `API liefert kein JSON. HTTP ${res.status}. Aufgerufen wurde: ${url}. Antwort beginnt mit: ${preview}`
        );
    }

    if (!res.ok || data?.ok === false) {
        throw new Error(data?.detail || data?.error || data?.message || `HTTP ${res.status}`);
    }

    return data;
}

export async function fetchGt3xCasesTesting({
                                                raceId = "",
                                                caseType = "incidents",
                                                seasonKey = "",
                                            } = {}) {
    return publicFetch(
        `/api/reko/public/gt3x/cases${qs({
            race_id: raceId,
            case_type: caseType,
            season_key: seasonKey,
        })}`
    );
}